import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, isAdmin, adminLoading } = useAuth();

  

  // Show loading while Auth0 is loading OR while checking admin role
  if (loading || adminLoading) {
    console.log('🔄 AdminRoute: Still loading authentication or admin status...');
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('❌ AdminRoute: Not authenticated, redirecting to home');
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    console.log('🚫 AdminRoute: Not admin, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  console.log('✅ AdminRoute: Access granted, rendering admin content');
  return children;
};

export default AdminRoute;